import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "py-2"
};
const _hoisted_2 = {
  class: "text-h5"
};
export default {
  __name: 'ConfirmationDialog',
  props: {
    title: {
      type: String,
      required: false
    },
    dialog: {
      type: Boolean,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    toggleText: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    showWarningIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["toggle-dialog", "confirm"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const toggleDialog = () => {
      emit("toggle-dialog");
    };
    const confirm = () => {
      emit("confirm");
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_btn = _resolveComponent("v-btn");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_dialog, {
          modelValue: props.dialog,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => props.dialog = $event),
          width: "800"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)]),
              _: 1
            }, 512), [[_vShow, __props.title]]), _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [__props.showWarningIcon ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                class: "mr-2",
                color: "warning"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-alert", -1)]))]),
                _: 1
              })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.content), 1)]),
              _: 1
            }), _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(_component_v_btn, {
                variant: "outlined",
                onClick: toggleDialog
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.toggleText), 1)]),
                _: 1
              }), _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "error",
                onClick: confirm
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
};